import {toNumber} from 'lodash-es';
import {OVRecommendActionEnum} from '../../../schema-types/globalTypes';
import type {ProtectionTypeEnum} from '../../../schema-types/globalTypes';
import validateUUID from '../../../utils/validateUUID';
import {
  getPotContactId,
  updateRecsVarsProps,
  upsertBuilderHeader,
} from './builderHelpers';

export const saveProtection = async (props: updateRecsVarsProps): Promise<string> => {
  const {accountId, values} = props;
  const {protectionPlan, contact, urgency, urgencyReason} = values;

  const ovrecommendId = await upsertBuilderHeader(props, {
    action: OVRecommendActionEnum.SET_UP_NEW,
    accountId: validateUUID(accountId),
    goalId: validateUUID(values.goal?.id),
    isNewPlanRequired: true,
    contactId: getPotContactId(contact),
    urgency,
    urgencyReason,
    note: protectionPlan?.notes,
  });

  await props.upsertBuilderProtection({
    variables: {
      ovrecommendId: validateUUID(ovrecommendId)!,
      protectionType: protectionPlan!.protectionType as ProtectionTypeEnum,
      criticalIllnessCover: protectionPlan?.criticalIllnessCover,
      deferredPeriod: protectionPlan?.deferredPeriod,
      isInTrust: protectionPlan?.inTrust,
      isInvestmentLinked: protectionPlan?.investmentLinked,
      lifeCover: protectionPlan?.lifeCover,
      lifeOrCriticalIllnessCover: protectionPlan?.lifeOrCriticalIllnessCover,
      livesAssured: protectionPlan?.livesAssured,
      monthlyIncome: protectionPlan?.monthlyIncome,
      notes: protectionPlan?.notes,
      premiumType: protectionPlan?.premiumType,
      term: toNumber(protectionPlan?.term) || undefined,
      termType: protectionPlan?.termType,
      terminatingAge: Number(protectionPlan?.terminatingAge) || undefined,
      isWaiverOfPremium: protectionPlan?.waiverOfPremium,
    },
  });

  return ovrecommendId;
};
